import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  CardDeck,
  Row,
  Col
  // CardBody
} from 'reactstrap';

import AdjoyabilityDial from '../../../shared/components/AdjoyabilityDial';
import StatCard from '../../../shared/components/StatCard';

class CampaignStats extends Component {
  getTotalConnections(){
    //SHOW A RANDOM VALUE IF IS EMPTY
    if(this.props.isUsingPlaceholderData) return 0;

    return this.props.brandKPIs
      .reduce((sum,kpi) => sum + kpi.connectionCount,0);
  }

  getTotalEngagements(){
    //SHOW A RANDOM VALUE IF IS EMPTY
    if(this.props.isUsingPlaceholderData) return 0;

    return this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.totalEngagements,0);
  }

  getTotalCompletions(){
    //SHOW A RANDOM VALUE IF IS EMPTY
    if(this.props.isUsingPlaceholderData) return 0;

    return this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.totalCompletions,0);
  }

  getTotalTimeSpent(){
    //SHOW A RANDOM VALUE IF IS EMPTY
    if(this.props.isUsingPlaceholderData) return '0 ';

    const campaignKPIs = this.props.campaignKPIs;

    const totalSeconds = campaignKPIs
      .filter((kpi) => kpi.totalTimeSpent && kpi.totalTimeSpent > 0)
      .reduce((sum,kpi) => sum + kpi.totalTimeSpent,0);

    if(!totalSeconds) return '0 sec'

    if(totalSeconds > 259200){
      return `${Math.floor((totalSeconds / 86400)).toLocaleString()} days`;
    }

    if(totalSeconds > 3600){
      return `${Math.floor(totalSeconds / 3600).toLocaleString()} hrs`;
    }

    if(totalSeconds > 60){
      return `${Math.floor(totalSeconds / 60).toLocaleString()} min`;
    }

    return `${totalSeconds.toLocaleString()} sec`;
  }

  getAverageTimeSpent(){
    const numerator = this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.avgTimeSpent * kpi.totalCompletions,0);

    const denominator = this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.totalCompletions,0);

    const averageSeconds = Math.round(numerator/denominator);

    return `${isNaN(averageSeconds) ? 0 : averageSeconds} sec`;
  }

  getAverageRating(){
    //SHOW A RANDOM VALUE IF IS EMPTY
    if(this.props.isUsingPlaceholderData) return null;

    const numerator = this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.averageRating * kpi.totalRatings,0);

    const denominator = this.props.campaignKPIs
      .reduce((sum,kpi) => sum + kpi.totalRatings,0);

    return Number.parseFloat(numerator / denominator).toFixed(1);
  }

  render(){
    return (
      <div
        className='CampaignStats'
        style={{ opacity: this.props.isGreyedOut ? 0.3 : 1 }}
      >
        <Row className='CampaignStatsRow'>
          {/*<Col xl='5' lg='12' md='12' className='CampaignStatsCol'>*/}
          {/*  <StatCard title={<span>Average Rating of <br />Your Experiences</span>}>*/}
          {/*    <div*/}
          {/*      id='AdjoyabilityDial'*/}
          {/*      className='mx-auto'*/}
          {/*      style={{width:260}}*/}
          {/*    >*/}
          {/*      <AdjoyabilityDial*/}
          {/*        width={260}*/}
          {/*        rating={this.getAverageRating()}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </StatCard>*/}
          {/*</Col>*/}
          <Col xs={12} sm={true} className='CampaignStatsCol'>
            <StatCard
              title={<span>Completed <br />Experiences</span>}
              value={(this.getTotalCompletions() || 0).toLocaleString()}
              description='Experiences consumers have completed to date.'
              icon='flag'
              width='15%'
            />
          </Col>
          <Col xs={12} sm={true} className='CampaignStatsCol'>
            <StatCard
              title={<span>Completed <br />Activities</span>}
              value={(this.getTotalEngagements() || 0).toLocaleString()}
              description='Total activities completed to date.'
              icon='speech'
              width='15%'
            />
          </Col>
          <Col xs={12} sm={true} className='CampaignStatsCol'>
            <StatCard
              title='Average Time per Experience'
              title={<span>Average Time <br />per Experience</span>}
              // value={this.getTotalTimeSpent() || '0:00'}
              value={this.getAverageTimeSpent()}
              unit=''
              description='Time users have spent engaging with you.'
              icon='time'
              width='15%'
            />
          </Col>
        </Row>
      </div>
    )
  }
}

CampaignStats.propTypes = {
  isEmpty:PropTypes.bool.isRequired,
  isGreyedOut:PropTypes.bool.isRequired,
  isUsingPlaceholderData:PropTypes.bool.isRequired,
  brandKPIs:PropTypes.arrayOf(PropTypes.shape({
    brandId:PropTypes.string.isRequired,
    brandName:PropTypes.string.isRequired,
    connectionCount:PropTypes.number.isRequired
  })).isRequired,
  campaignKPIs:PropTypes.arrayOf(PropTypes.shape({
    averageRating:PropTypes.number,
    brandId:PropTypes.string.isRequired,
    campaignId:PropTypes.string.isRequired,
    totalCompletions:PropTypes.number.isRequired,
    totalRatings:PropTypes.number.isRequired,
    totalEngagements:PropTypes.number.isRequired,
    totalTimeSpent:PropTypes.number.isRequired
  })).isRequired
};

CampaignStats.defaultProps = {
  isEmpty:false,
  isGreyedOut:false,
  isUsingPlaceholderData:false,
  brandKPIs:[],
  campaignKPIs:[]
};

export default CampaignStats;



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/components/CampaignStats.js